(function () {
  'use strict';

  function trackFormSuccess(form, source) {
    if (!window.tcbAnalytics) return;
    var topic = '';
    var topicField = form.querySelector('[name="contact[topic]"], #tcb-contact-topic, [name="contact[tags]"]');
    if (topicField) topic = topicField.value || '';
    if (window.tcbAnalytics.formSubmitted) {
      window.tcbAnalytics.formSubmitted(source, topic);
    } else if (window.tcbAnalytics.quoteRequested) {
      window.tcbAnalytics.quoteRequested(source, topic);
    }
  }

  function boot() {
    if (document.querySelector('.tcb-contact-alert--success')) {
      trackFormSuccess(document.getElementById('tcb-contact-form-el') || document.body, 'contact_page');
    }

    document.querySelectorAll('form[id="tcb-footer-newsletter"], form[id="footer-newsletter"]').forEach(function (form) {
      if (form.querySelector('.tcb-footer__newsletter-success, .alert--success, [data-form-status="success"]')) {
        if (window.tcbAnalytics && window.tcbAnalytics.newsletterSubscribed) {
          window.tcbAnalytics.newsletterSubscribed('footer');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
